import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    apiData: {},  // stores results by API name
    loading: {},
    error: {}
  },
  reducers: {
    apiStart: (state, action) => {
      state.loading[action.payload] = true;
      state.error[action.payload] = null;
    },
    apiSuccess: (state, action) => {
      const { key, data } = action.payload;
      state.loading[key] = false;
      state.apiData[key] = data;
    },
    apiFailure: (state, action) => {
      const { key, error } = action.payload;
      state.loading[key] = false;
      state.error[key] = error;
    }
  }
});

export const { apiStart, apiSuccess, apiFailure } = dataSlice.actions;
export default dataSlice.reducer;
